import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import SVGImage from "./SVGImage";

function TaglineWithSVG({ metrics }) {
  const taglines = [
    "Fast Sites Win Hearts and Rankings.",
    "Accelerate Your Web, Elevate Your Impact.",
    "Speed Drives SEO. Delight Fuels Success.",
    "Faster Sites, Happier Users, Better SEO.",
    "Boost Speed. Boost SEO. Boost Success.",
    "Speed Matters. For Search and Satisfaction.",
    "Make Every Millisecond Count.",
    "Where Speed Meets SEO Brilliance.",
    "Fast for Search. Perfect for Users.",
    "Your Shortcut to a Faster, Smarter Website.",
    "Speed: The Secret Sauce for SEO and Satisfaction.",
    "Fuel Your Site's Speed for Ultimate Success.",
    "Fast Websites, Happy Users, Top Rankings.",
    "Win Google. Wow Users.",
    "Speed is the New Competitive Edge.",
    "Lightning-Fast Sites for Winning Experiences.",
    "Rank Higher, Engage Faster, Impress Always.",
    "Fast Websites. Smarter Results.",
    "Speed Up, Stand Out.",
    "Power Your Site. Please Your Users.",
    "Built for Speed, Loved by Users, Ranked by Google.",
    "Fast Websites Lead the Digital Race.",
    "Speed Up, Level Up.",
    "The Faster, The Better. For Users and SEO.",
    "Optimize Speed. Maximize Impact.",
    "Your Shortcut to Digital Success.",
    "Faster Sites, Greater Heights.",
    "Performance That Gets Noticed.",
    "Speed: The Key to Engagement and Rankings.",
    "Speed Wins Every Click and Search.",
    "Speed Isn't Optional. It's Essential.",
    "Go Fast or Get Left Behind.",
    "Fast Sites, Happy Users, Top Rankings.",
    "Fuel Your Web Performance, Rule the Search.",
    "Speed Up. Show Up. Stand Out.",
    "Accelerate for Impact and Visibility.",
    "Be Fast, Be First.",
    "Speed Powers SEO and User Smiles.",
    "Optimize Speed. Dominate Search.",
    "Fast Loads, Lasting Impressions.",
  ];

  const [tagline, setTagline] = useState("");

  useEffect(() => {
    // Select a random tagline
    const randomTagline = taglines[Math.floor(Math.random() * taglines.length)];
    setTagline(randomTagline);
  }, []);

  return (
    !metrics && (
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.15,
              delayChildren: 0.1,
            },
          },
        }}
      >
        <motion.h3
          variants={{
            hidden: { opacity: 0, y: 12 },
            visible: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="text-md font-bold text-[#000000de] mb-8 mt-8 text-center select-none"
        >
          {tagline}
        </motion.h3>
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 16 },
            visible: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="flex justify-center"
        >
          <SVGImage className="w-full max-w-[200px] h-auto" />
        </motion.div>
      </motion.div>
    )
  );
}

export default TaglineWithSVG;
